async function renderSwatchesGallery() {
    const swatchesGallery = document.querySelector('.swatches-gallery');
    const pimUrl = swatchesGallery.dataset.pimUrl;
    const handle = swatchesGallery.dataset.handle;

    const variantsData = await fetch(
      `${pimUrl}/api/styles/${handle}/variants/gaia`
    );
    const data = (await variantsData.json()).data;

    const colourGroups = data.reduce((acc, v) => {
        (acc[v.colour.id] = acc[v.colour.id] || []).push(v);
        return acc;
    }, {});
    const discontinuedColourIds = new Set(
        Object.entries(colourGroups)
            .filter(([, group]) => group.every((v) => v.discontinued))
            .map(([id]) => Number(id))
    );

    const variants = [];
    data.forEach((variant) => {
      if (variants.some((v) => v.colour.id === variant.colour.id) || !variant.front_image_url) {
        return;
      }
      variants.push({ ...variant, discontinued: discontinuedColourIds.has(variant.colour.id) });
    });

    const swatchesContainer = document.querySelector('.swatches-container');
    const swatchButtonTemplate = swatchesContainer.querySelector('.swatch-item');
    swatchButtonTemplate.remove();
    swatchButtonTemplate.style.display = 'block';

    for (const variant of variants) {
      const swatchButton = swatchButtonTemplate.cloneNode(true);
      const swatchImage = swatchButton.querySelector('.swatch-img');
      const swatchColor = swatchButton.querySelector('.swatch-color');
      const url = new URL(variant.front_image_url);
      url.searchParams.set('width', 120);
      swatchImage.src = url.toString();
      swatchImage.alt = variant.colour.name.en;
      swatchColor.textContent = variant.colour.name.en;
      swatchesContainer.appendChild(swatchButton);
    }

    document.body.appendChild(swatchesGallery);

    const swiperContainer = swatchesGallery.querySelector('.swatches-gallery__swiper');
    const zoomContainer = swatchesGallery.querySelector('.swatches-gallery__zoom-container');
    const loadingContainer = swatchesGallery.querySelector('.swatches-gallery__zoom-loading-container');
    const errorContainer = swatchesGallery.querySelector('.swatches-gallery__zoom-error-container');
    const zoomImageContainer = swatchesGallery.querySelector('.swatches-gallery__zoom-image-container');
    const fullscreenImageContainer = swatchesGallery.querySelector('.swatches-gallery__fullscreen-image-container');

    const swiperWrapper = swatchesGallery.querySelector('.swiper-wrapper');

    const swiperSlideTemplate = swatchesGallery.querySelector('.swatches-gallery__template');
    swiperSlideTemplate.remove();
    swiperSlideTemplate.classList.remove('swatches-gallery__template');

    for (const variant of variants) {
      const swiperSlide = swiperSlideTemplate.cloneNode(true);
      swiperWrapper.appendChild(swiperSlide);

      const colourTitle = swiperSlide.querySelector('.swatches-gallery__swiper-colour-title');
      colourTitle.textContent = variant.colour.name.en;

      const colourCode = swiperSlide.querySelector('.swatches-gallery__swiper-colour-code');
      colourCode.textContent = variant.colour.code;

      if (variant.discontinued) {
        const discontinued = document.createElement('h5');
        discontinued.textContent = '(Discontinued)';
        discontinued.className = 'swatches-gallery__swiper-colour-discontinued';
        colourCode.insertAdjacentElement('afterend', discontinued);
      }

      const buttonContainer = swiperSlide.querySelector('.swatches-gallery__swiper-button-container');
      const zoomButton = buttonContainer.querySelector('.swatches-gallery__zoom-button');
      const reverseButton = buttonContainer.querySelector('.swatches-gallery__reverse-button');
      
      if (!variant.back_image_url) {
        reverseButton.disabled = true;
        reverseButton.classList.add('swatches-gallery__reverse-button--disabled');
      }

      const imageContainer = swiperSlide.querySelector('.swatches-gallery__swiper-image-container');

      function getImageSrcset(imageUrl) {
        return Array.from({length: 10}).map((_, i) => `${imageUrl}?width=${(i + 1) * 200} ${200 * (i + 1)}w`).join(', ');
      }

      const frontImage = imageContainer.querySelector('.swatches-gallery__swiper-image-front');
      frontImage.loading = 'lazy';
      frontImage.srcset = getImageSrcset(variant.front_image_url);
      frontImage.src = variant.front_image_url;
      frontImage.alt = variant.colour.name.en;

      const backImage = imageContainer.querySelector('.swatches-gallery__swiper-image-back');
      backImage.loading = 'lazy';
      backImage.srcset = getImageSrcset(variant.back_image_url);
      backImage.src = variant.back_image_url;
      backImage.alt = variant.colour.name.en;

      reverseButton.addEventListener('click', () => {
        reverseImage(frontImage, backImage);
      });

      function reverseImage(frontImage, backImage) {
        frontImage.classList.toggle('swatches-gallery__swiper-image__reverse');
        backImage.classList.toggle('swatches-gallery__swiper-image__reverse');
      }

      zoomButton.addEventListener('click', (event) => {
        zoomContainer.classList.add('swatches-gallery__zoom-container--open');
        const image = frontImage.classList.contains('swatches-gallery__swiper-image__reverse') ? backImage : frontImage;
        const imageElement = document.createElement('img');
        imageElement.src = image.src;
        imageElement.alt = image.alt;
        // set srcset and sizes
        const srcset = Array.from({length: 15}).map((_, i) => `${image.src}?width=${(i + 1) * 200} ${200 * (i + 1)}w`).join(', ');
        imageElement.srcset = srcset;
        const isWindowHeightLargerThanWidth = window.innerHeight > window.innerWidth;
        let sizes = '';
        if (isWindowHeightLargerThanWidth) {
          const windowSizeRatio = window.innerHeight / window.innerWidth;
          sizes = `${(windowSizeRatio * 100).toFixed(0)}vw`;
        } else {
          sizes = '100vw';
        }
        imageElement.sizes = sizes;


        const fullscreenImageElement = imageElement.cloneNode(true);
        fullscreenImageElement.classList.add('swatches-gallery__fullscreen-image');
        fullscreenImageContainer.appendChild(fullscreenImageElement);

        fullscreenImageElement.addEventListener('load', (event) => {
          zoomContainer.classList.remove('swatches-gallery__zoom-container--loading');
          zoomContainer.classList.add('swatches-gallery__zoom-container--show_fullscreen_image');
        });
        fullscreenImageElement.addEventListener('error', (event) => {
          zoomContainer.classList.remove('swatches-gallery__zoom-container--loading');
          zoomContainer.classList.add('swatches-gallery__zoom-container--error');
        });

        imageElement.classList.add('swatches-gallery__zoom-image');
        zoomImageContainer.appendChild(imageElement);

        

        onZoomMouseMove(event);
      });
    }

    function closeZoomContainer() {
      const zoomContainer = swatchesGallery.querySelector('.swatches-gallery__zoom-container');
      zoomContainer.classList.remove('swatches-gallery__zoom-container--open');
      zoomContainer.classList.add('swatches-gallery__zoom-container--loading');
      zoomContainer.classList.remove('swatches-gallery__zoom-container--error');
      zoomContainer.classList.remove('swatches-gallery__zoom-container--show_fullscreen_image');
      fullscreenImageContainer.innerHTML = '';
      zoomImageContainer.innerHTML = '';
    }

    fullscreenImageContainer.addEventListener('click', (event) => {
      zoomContainer.classList.remove('swatches-gallery__zoom-container--show_fullscreen_image');
    });
    loadingContainer.addEventListener('click', () => {
      closeZoomContainer();
    });
    errorContainer.addEventListener('click', () => {
      closeZoomContainer();
    });
    zoomImageContainer.addEventListener('click', () => {
      closeZoomContainer();
    });
    function onZoomMouseMove(event) {
      const zoomImage = zoomImageContainer.querySelector('.swatches-gallery__zoom-image');
      const zoomImageRect = zoomImage.getBoundingClientRect();
      const zoomContainerRect = zoomContainer.getBoundingClientRect();
      const zoomContainerXPercent = (event.clientX - zoomContainerRect.left) / zoomContainerRect.width - 0.5; // normalize to -0.5 to 0.5
      const zoomContainerYPercent = (event.clientY - zoomContainerRect.top) / zoomContainerRect.height - 0.5; // normalize to -0.5 to 0.5
      const zoomImageTranslateX = zoomContainerXPercent * -100;
      const zoomImageTranslateY = zoomContainerYPercent * -100;
      zoomImage.style.transform = `translate(${zoomImageTranslateX}%, ${zoomImageTranslateY}%)`;
    }
    zoomContainer.addEventListener('mousemove', onZoomMouseMove);

    const swiper = new Swiper(swiperContainer, {
      direction: 'horizontal',
      breakpoints: {
        750: {
          slidesPerView: 4.3,
          spaceBetween: 0,
        },
      },
      slidesPerView: 2,
      spaceBetween: 0,
      centeredSlides: true,
      speed: 300,
      on: {
        slideChange: updateButtons,
      },
    });

    updateButtons(swiper);

    function updateButtons(swiper) {
      const prevButton = swatchesGallery.querySelector('.swatches-gallery__prev');
      const nextButton = swatchesGallery.querySelector('.swatches-gallery__next');
      prevButton.classList.toggle('swatches-gallery__prev--disabled', swiper.activeIndex === 0);
      nextButton.classList.toggle('swatches-gallery__next--disabled', swiper.activeIndex === swiper.slides.length - 1);
    }

    function openSwatchesGallery(index) {
      if (variants.length === 0) {
        return;
      }
      swiper.slideTo(index);
      swatchesGallery.classList.add('swatches-gallery__open');
      document.body.classList.add('overflow-hidden');
    }

    function closeSwatchesGallery() {
      swatchesGallery.classList.remove('swatches-gallery__open');
      document.body.classList.remove('overflow-hidden');
    }

    const swatches = document.getElementsByClassName('swatch-img');
    for (const swatch of swatches) {
      swatch.addEventListener('click', () => {
        const index = Array.from(swatches).indexOf(swatch);
        openSwatchesGallery(index);
      });
    }

    const closeButton = swatchesGallery.querySelector('.swatches-gallery__close');
    closeButton.addEventListener('click', () => {
      closeSwatchesGallery();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        if (zoomContainer.classList.contains('swatches-gallery__zoom-container--open')) {
          closeZoomContainer();
        } else {
          closeSwatchesGallery();
        }
      }
    });

    const prevButton = swatchesGallery.querySelector('.swatches-gallery__prev');
    prevButton.addEventListener('click', () => {
      swiper.slidePrev();
    });

    const nextButton = swatchesGallery.querySelector('.swatches-gallery__next');
    nextButton.addEventListener('click', () => {
      swiper.slideNext();
    });
  }

  renderSwatchesGallery();